const translations = {
  seo: {
    title: "Slot vervangen Eindhoven | Cilinder, voordeur, SKG | Vanaf €85",
    description: "Slot of cilinder vervangen in Eindhoven? Voordeur, schuifpui. SKG-keurmerk. Spoedservice 7/7. Vanaf €85. Bel 040 798 7470.",
  },
  breadcrumb: {
    home: "Home",
    diensten: "Diensten",
    current: "Slot vervangen",
  },
  hero: {
    pill: "DIENST — SLOT EN CILINDER VERVANGEN",
    h1: "Slot- en cilindervervanging in Eindhoven",
    subhead: "Voordeur, achterdeur, schuifpui of binnendeur — wij vervangen sloten en cilinders snel en veilig. SKG-keurmerk gegarandeerd. Spoedservice 7 dagen per week.",
    usps: [
      "Vanaf €85",
      "Spoed binnen 2 uur",
      "SKG** en SKG***",
    ],
    ctaPhone: "040 798 7470",
    ctaOfferte: "Gratis offerte",
  },
  spoedBanner: {
    text: "🚨 SLEUTEL KWIJT OF NA INBRAAK? Binnen 2 uur voor uw deur. Bel: 040 798 7470",
  },
  intro: {
    h2: "Wanneer is slotvervanging nodig?",
    p1: "Een nieuw slot is een kleine investering met groot effect. Na een inbraak is direct vervangen een verzekeringseis — zonder de juiste keurmerken bent u niet verzekerd.",
    p2: "Ook bij sleutelverlies, verhuizing of upgrade naar SKG*** is slotvervanging het verstandige antwoord. Wij vervangen sloten van voordeuren, achterdeuren, schuifpuien, draaikiepramen en binnendeuren.",
    p3: "Wij plaatsen uitsluitend SKG***-gecertificeerde cilinders van M&C, Mauer, ABUS, DOM, Nemef en Lips. Vaak klaar binnen 30 minuten met 10 jaar garantie.",
  },
  wanneer: {
    h2: "In welke situaties?",
    rows: [
      {
        title: "Na inbraak",
        desc: "Cilinder geboord of geforceerd. Verzekeringseis. Wij maken het schadedossier.",
      },
      {
        title: "Sleutel kwijt",
        desc: "Iemand anders kan binnen. Wij vervangen snel, ook 's avonds en in het weekend.",
      },
      {
        title: "Slot werkt niet",
        desc: "Vastlopen of moeilijk draaien — interne slijtage. Vervangen is goedkoper dan repareren.",
      },
      {
        title: "Verhuizing",
        desc: "U weet niet wie nog een sleutel heeft. Nieuwe cilinder geeft gemoedsrust.",
      },
      {
        title: "Upgrade SKG***",
        desc: "Verzekeringseis of extra veiligheid. Anti-kerntrek en boorbescherming.",
      },
      {
        title: "Schuifpui of draaikiepraam",
        desc: "Specifieke cilinders. Wij werken met alle merken.",
      },
    ],
  },
  typesSloten: {
    h2: "Welke sloten vervangen wij?",
    items: [
      { nr: "01", title: "Cilinderslot voordeur", desc: "Standaard en SKG" },
      { nr: "02", title: "Meerpuntssluiting", desc: "Extra inbraakwering" },
      { nr: "03", title: "SKG** en SKG***", desc: "Verzekeringsconform" },
      { nr: "04", title: "Slot schuifpui", desc: "Specifieke uitvoering" },
      { nr: "05", title: "Slot draaikiepraam", desc: "Kleine cilinder" },
      { nr: "06", title: "Wc-deur en binnendeur", desc: "Snel en goedkoop" },
    ],
  },
  skg: {
    h2: "Waarom SKG?",
    p1: "SKG is de Nederlandse standaard voor inbraakwerendheid. Verzekeraars eisen vaak SKG** of SKG*** voor uitkering bij inbraak.",
    p2: "SKG*** sloten hebben anti-kerntrek en boorbescherming. Een inbreker geeft op binnen 5 min — bij SKG*** vaak al binnen 3 min.",
  },
  werkwijze: {
    h2: "Vervanging in 4 stappen",
    steps: [
      { nr: "01", title: "Aanvraag", desc: "Bel of formulier" },
      { nr: "02", title: "Diagnose", desc: "Type + advies SKG" },
      { nr: "03", title: "Vervanging", desc: "Vaak binnen 30 min" },
      { nr: "04", title: "Garantie", desc: "10 jaar schriftelijk" },
    ],
  },
  prijzen: {
    h2: "Kosten slot vervangen",
    note: "Excl. 21% BTW. Spoedtoeslag avond/weekend op aanvraag.",
    rows: [
      { dienst: "Diagnose + offerte", prijs: "Gratis", tijd: "15 min" },
      { dienst: "Cilinder standaard", prijs: "€85", tijd: "30 min" },
      { dienst: "Cilinder SKG**", prijs: "€115", tijd: "30 min" },
      { dienst: "Cilinder SKG***", prijs: "€145", tijd: "30 min" },
      { dienst: "Volledig slot voordeur", prijs: "€185", tijd: "1-2u" },
      { dienst: "Slot na inbraak (spoed)", prijs: "€165", tijd: "1-2u" },
      { dienst: "Slot binnendeur / wc", prijs: "€65", tijd: "20 min" },
    ],
  },
  waarom: {
    h2: "Waarom wij?",
    reasons: [
      { nr: "01", title: "Spoedservice 7/7", desc: "Ook 's nachts" },
      { nr: "02", title: "SKG-gecertificeerd", desc: "Verzekeringsconform" },
      { nr: "03", title: "Originele cilinders", desc: "M&C, Mauer, ABUS, DOM, Nemef, Lips" },
      { nr: "04", title: "10 jaar garantie", desc: "Schriftelijk" },
    ],
  },
  faq: {
    h2: "Veelgestelde vragen",
    items: [
      { q: "Hoe snel kunt u een sleutel kwijt oplossen?", a: "Bij een verloren sleutel vervangen wij de cilinder zodra u belt. Bij spoed zijn wij binnen 2 uur ter plaatse in Eindhoven. U krijgt een nieuwe cilinder met passende sleutels." },
      { q: "Wat kost het vervangen van een cilinder?", a: "Een standaard cilinder vervangen kost vanaf €85. SKG** cilinders vanaf €115 en SKG*** vanaf €145. Dit is inclusief arbeid en nieuwe sleutels. Materialen worden op werkelijke kostprijs doorberekend." },
      { q: "Wat is het verschil tussen SKG**, SKG*** en SKG****?", a: "SKG** biedt basis inbraakwerendheid. SKG*** heeft anti-kerntrek en boorbescherming. SKG**** is het hoogste niveau met extra versteviging. Voor de meeste verzekeraars is SKG*** voldoende." },
      { q: "Wat na een inbraak — is slot vervanging verplicht?", a: "Bijna elke verzekeraar eist SKG** of SKG*** na een inbraak. Wij leveren een schadedossier met foto's en een factuur voor uw verzekering. Zonder vervanging kunt u het risico lopen dat uw verzekering niet uitkeert." },
      { q: "Kunnen meerdere deuren op gelijke sleutel?", a: "Ja, wij kunnen meerdere cilinders gelijksluitend maken. Handig bij een voordeur, achterdeur en schuifpui die op dezelfde sleutel moeten openen. U betaalt hier een kleine meerprijs per extra deur." },
      { q: "Werken jullie ook 's nachts?", a: "Ja, wij bieden spoedservice 7 dagen per week, ook 's nachts en in het weekend. Voor avond- en nachtwerken geldt een kleine spoedtoeslag. Bel ons op 040 798 7470." },
    ],
  },
  links: {
    h2: "Meer diensten",
    cards: [
      { title: "Slotenmaker 24/7", desc: "Buitengesloten of spoed ? Onze slotenmaker in Eindhoven is 24/7 beschikbaar.", href: "/slotenmaker-eindhoven/" },
      { title: "Inbraakschade", desc: "Wilt u meer weten over inbraakschade reparatie?", href: "/inbraakschade-reparatie/" },
      { title: "Kozijnreparatie", desc: "Wilt u meer weten over kozijnreparatie?", href: "/kozijn-reparatie/" },
      { title: "Schuifpui reparatie", desc: "Wilt u meer weten over schuifpui reparatie?", href: "/schuifpui-reparatie/" },
    ],
  },
  ctaBanner: {
    h2: "Slot kapot in Eindhoven?",
    cta: "📞 Bel 040 798 7470",
  },
  offerte: {
    h2: "Gratis offerte aanvragen",
    intro: "Vertel ons wat u nodig heeft en wij nemen contact op.",
    steps: ["Situatie", "Deurtype", "Contact"],
    step1: {
      label: "Waarom wilt u het slot vervangen?",
      options: [
        "Inbraakschade",
        "Sleutel verloren",
        "Slot werkt niet goed",
        "Verhuizing",
        "Upgrade naar SKG",
        "Anders",
      ],
    },
    step2: {
      label: "Om welk type deur gaat het?",
      options: [
        "Voordeur",
        "Achterdeur",
        "Schuifpui",
        "Draaikiepraam",
        "Binnendeur",
        "WC-deur",
      ],
    },
    step3: {
      firstName: "Voornaam",
      lastName: "Achternaam",
      phone: "Telefoon",
      email: "E-mail",
      address: "Adres",
      message: "Bericht",
      back: "Terug",
      next: "Volgende",
      submit: "Verstuur aanvraag",
    },
  },
};

export default translations;